var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card_animation_wrap" }, [
    _c("div", { staticClass: "card_animation" }, [
      _vm.img
        ? _c("img", { staticClass: "animation_bg", attrs: { src: _vm.img } })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/cardAnimation.vue?vue&type=template&id=54a883a2&
// module id = null
// module chunks = 